import * as React from "react";
const IconDesktopApp = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || "48"}
    height={props.size || "48"}
    
    viewBox="0 0 48 48"
    {...props}
  >
    <path
      
      fillRule="evenodd"
      d="M9.176 8.5C7.422 8.5 6 9.94 6 11.714V31c0 1.775 1.422 3.214 3.176 3.214h10.589v2.143h-4.236V38.5h16.942v-2.143h-4.236v-2.143h10.589C40.578 34.214 42 32.775 42 31V11.714C42 9.94 40.578 8.5 38.824 8.5zm12.706 27.857h4.236v-2.143h-4.236zM8.118 11.714c0-.591.474-1.071 1.058-1.071h29.648c.584 0 1.058.48 1.058 1.071V31c0 .592-.474 1.071-1.058 1.071H9.176c-.584 0-1.058-.48-1.058-1.071zm7.411 1.072h-2.117v2.143h-2.118v2.142h2.118v2.143h2.117v-2.143h2.118V14.93h-2.118zm-3.176 8.571c-.585 0-1.06.48-1.06 1.072v4.285c0 .592.475 1.072 1.06 1.072h4.235c.585 0 1.059-.48 1.059-1.072V22.43c0-.592-.474-1.072-1.059-1.072zm1.059 4.286V23.5h2.117v2.143zm7.412-11.786c0-.592.474-1.071 1.059-1.071h4.235c.585 0 1.059.48 1.059 1.071v4.286c0 .592-.474 1.071-1.06 1.071h-4.234c-.585 0-1.06-.48-1.06-1.071zm2.117 1.072v2.142h2.118V14.93zm-1.058 6.428c-.585 0-1.06.48-1.06 1.072v4.285c0 .592.475 1.072 1.06 1.072h4.235c.585 0 1.059-.48 1.059-1.072V22.43c0-.592-.474-1.072-1.06-1.072zm1.058 4.286V23.5h2.118v2.143zm7.412-11.786c0-.592.474-1.071 1.059-1.071h4.235c.585 0 1.059.48 1.059 1.071v4.286c0 .592-.474 1.071-1.059 1.071h-4.235c-.585 0-1.059-.48-1.059-1.071zm2.118 1.072v2.142h2.117V14.93z"
      clipRule="evenodd"
    />
  </svg>
);
export default IconDesktopApp;
